var moduleMap = {
	"./MainLayout": () => {
		return Promise.all([__webpack_require__.e(236), __webpack_require__.e(668), __webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(314), __webpack_require__.e(292), __webpack_require__.e(33)]).then(() => (() => ((__webpack_require__(3958)))));
	},
	"./ErrorBoundary": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(266)]).then(() => (() => ((__webpack_require__(2266)))));
	},
	"./TimeConnected": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(314), __webpack_require__.e(878)]).then(() => (() => ((__webpack_require__(1878)))));
	},
	"./AppMultiSelect": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(592)]).then(() => (() => ((__webpack_require__(3592)))));
	},
	"./NotAuthorized": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(548), __webpack_require__.e(402)]).then(() => (() => ((__webpack_require__(5402)))));
	},
	"./NotFound": () => {
		return Promise.all([__webpack_require__.e(236), __webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(77)]).then(() => (() => ((__webpack_require__(6077)))));
	},
	"./AppSelect": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(487)]).then(() => (() => ((__webpack_require__(7487)))));
	},
	"./AppSwitch": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(847)]).then(() => (() => ((__webpack_require__(2847)))));
	},
	"./AppInput": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(499)]).then(() => (() => ((__webpack_require__(9499)))));
	},
	"./AppTextArea": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(893)]).then(() => (() => ((__webpack_require__(5893)))));
	},
	"./AppCustomCheckbox": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(275)]).then(() => (() => ((__webpack_require__(8275)))));
	},
	"./AppButton": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(143)]).then(() => (() => ((__webpack_require__(7143)))));
	},
	"./ManageSideDrawer": () => {
		return Promise.all([__webpack_require__.e(236), __webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(799)]).then(() => (() => ((__webpack_require__(6799)))));
	},
	"./RecordTotalCount": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(940)]).then(() => (() => ((__webpack_require__(940)))));
	},
	"./AppPagination": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(117)]).then(() => (() => ((__webpack_require__(5117)))));
	},
	"./AppCustomizedPagination": () => {
		return Promise.all([__webpack_require__.e(236), __webpack_require__.e(884), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(715)]).then(() => (() => ((__webpack_require__(9715)))));
	},
	"./IndexStyle": () => {
		return __webpack_require__.e(78).then(() => (() => ((__webpack_require__(9078)))));
	},
	"./LayoutStyle": () => {
		return __webpack_require__.e(632).then(() => (() => ((__webpack_require__(9632)))));
	},
	"./OverrideStyle": () => {
		return __webpack_require__.e(175).then(() => (() => ((__webpack_require__(3175)))));
	},
	"./IconSvg": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(518)]).then(() => (() => ((__webpack_require__(518)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});